export default "__VITE_ASSET__BvMWIm7L__"